import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from '@mui/material';

import { useDate } from "../../../utility/useDate";


const KmosDialogHeader: FC<{
  startTime: string;
  endTime: string;
  pickByTime: string;
  date: string;
  title: string;
}> = ({ startTime, endTime, pickByTime, date, title: name }) => {
  const { toFormattedFullDateString } = useDate();
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 1, textAlign: 'center' }}>
      <Typography variant="h6" fontWeight="bold">
        {`${toFormattedFullDateString(date)} ${name} ${startTime} - ${endTime}`}
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        {t("kmos.labels.pickBy", { time: pickByTime })}
      </Typography>
    </Box>
  );
};

export default KmosDialogHeader;
